<ion-header>
  <ion-toolbar mode="md">
    <ion-title>
      <ion-text *ngIf="order && order.order_id">#{{ order.order_id }}</ion-text>
      <ion-text *ngIf="order && order.short_order_id">
        ({{ order.short_order_id }})
      </ion-text>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" fill="clear" (click)="closeModal()">
        <ion-icon slot="icon-only" src="assets/ionicons/close.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="false">
  <ion-grid class="cash-change-grid">
    <ion-row>
      <ion-col size="12" class="ion-text-center">
        <ion-text class="order-total-label">
          {{ "orders.cash-change-calculator.order-total" | translate }}
        </ion-text>
        <div class="order-total">
          {{ orderTotalDisplay }}{{ currencySymbol }}
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="paid-amount-title-row">
      <ion-col size="12" class="ion-text-center">
        <ion-text class="paid-amount-title">
          {{ "orders.cash-change-calculator.paid-amount" | translate }}
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row class="quick-amounts-row">
      <ion-col size="4" *ngFor="let amount of quickAmounts">
        <ion-button
          class="quick-amount-button"
          expand="block"
          fill="solid"
          color="primary"
          (click)="selectQuickAmount(amount.value)"
        >
          {{ amount.label }}{{ currencySymbol }}
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row class="paid-amount-display-row">
      <ion-col size="12">
        <div
          class="paid-amount-display"
          [class.paid-amount-display-empty]="!paidAmountDisplay"
        >
          <span *ngIf="paidAmountDisplay">
            {{ paidAmountDisplay }}{{ currencySymbol }}
          </span>
          <span *ngIf="!paidAmountDisplay">
            {{ "orders.cash-change-calculator.enter-amount" | translate }}
          </span>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="keyboard-row">
      <ion-col size="12">
        <div #simpleKeyboard class="simple-keyboard cash-change-keyboard"></div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" class="ion-text-center">
        <ion-text color="danger" *ngIf="insufficientAmount">
          {{ "orders.cash-change-calculator.insufficient-amount" | translate }}
        </ion-text>

        <div class="change-result" *ngIf="showChangeAmount">
          <ion-text class="change-label">
            {{ "orders.cash-change-calculator.change" | translate }}
          </ion-text>
          <div class="change-amount">
            {{ changeAmountDisplay }}{{ currencySymbol }}
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="done-button-container">
      <ion-button class="done-button" color="primary" (click)="closeModal()">
        {{ "orders.cash-change-calculator.done" | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
